import firebase from "firebase/app";
import "firebase/auth"
import 'firebase/database'


const firebaseConfig = {
    apiKey: "AIzaSyBqb1diYKQ-IOzBu9x26ghiKHSkg1hve2Y",
    authDomain: "racs-app-ut.firebaseapp.com",
    projectId: "racs-app-ut",
    databaseURL: "https://racs-app-ut-default-rtdb.firebaseio.com",
    storageBucket: "racs-app-ut.appspot.com",
    messagingSenderId: "377806638859",
    appId: "1:377806638859:web:e2be10f6990fefe27a5c0e"
  };
  
  // This must run before any other firebase functions
  firebase.initializeApp(firebaseConfig)

  export default firebase;